import { useContext } from "react";

import { ProductPageContext } from "shared/product/ProductPageContext/index";

export const useProductPageContext = () => {
  const productPageContext = useContext(ProductPageContext);

  if (productPageContext === undefined) {
    throw new Error(
      "useProductPageContext must be used within ProductPageContextProvider",
    );
  }

  return productPageContext;
};
